exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 990;\n}\n.dropdown-item {\n  cursor: pointer;\n}\n.dropdown-item:hover {\n  cursor: pointer;\n}\n.dropdown.show .dropdown-menu {\n  display: block;\n}\n.dropdown-menu-right {\n  right: 0px;\n  left: inherit;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/plain-dropdown/plain-dropdown.component.less
// module id = ../../../../../src/app/shared/plain-dropdown/plain-dropdown.component.less
// module chunks = 2